import { render, staticRenderFns } from "./PaymentDueDatesTable.vue?vue&type=template&id=070a0f6e"
import script from "./PaymentDueDatesTable.vue?vue&type=script&lang=js"
export * from "./PaymentDueDatesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports